import type { Instacart_Catalog_Catflow_V1_StepVersion } from '../../../../api'
import { type PipelineStep } from '../../../../types/attributeManagement.types.ts'

export const CAMP_CLIENT_ID = 'catalog_camp_ipp'

export interface PipelineEditorAttributes {
  steps: PipelineStep[]
  pipelineVersion?: number
  hoursInterval: number
  enableSchedule: false
  firstPipelineStepId: string
}

export interface PipelineEditorGraphInput {
  firstPipelineStepId: string | null
  pipelineStepIdToStepMap: {
    [p: string]: PipelineEditorGraphInputStep
  }
}

export interface PipelineEditorGraphInputStep {
  step: PipelineStep
  stepVersion?: Instacart_Catalog_Catflow_V1_StepVersion | null | undefined
}
